
import { RadarChart } from 'echarts/charts'
import { LegendComponent, TimelineComponent } from 'echarts/components'
import { init as initChart, use as useChart } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import isEmpty from 'lodash/isEmpty'

import attributesTranslations from '../Table/Row.translations'

import { chartOptions } from './Chart.constants'
import translations from './Chart.translations'

useChart([RadarChart, SVGRenderer, LegendComponent, TimelineComponent])

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    chart() {
      const getScores = (index) =>
        this.productsCategoriesScores[index].map((cat) => {
          if (cat.value.benchmark !== null) {
            return cat.value.benchmark
          }

          return cat.value.internal
        })

      const getCategories = (index) =>
        this.productsCategoriesScores[index].map(({ label }) => {
          const translation = Object.values(attributesTranslations).find(
            ({ id }) => id === label,
          )

          return {
            name: this.$t(translation),
            max: 100,
          }
        })

      const config = {
        title: this.$t(translations.attributesTitle),
        series: Array.from({ length: 2 }).map(() => ({})),
        legend: Array.from({ length: 2 }),
        categories: getCategories(0),
      }

      config.series = config.series.map((serie, index) => {
        return {
          name: this.data.modelsNames[index],
          value: getScores(index),
        }
      })

      config.legend = config.series.map((serie, index) => {
        return this.data.modelsNames[index]
      })

      return config
    },

    options() {
      const options = { ...chartOptions }
      options.baseOption.radar.indicator = this.chart.categories
      if (!isEmpty(options.baseOption.series)) {
        options.baseOption.series[0].data.forEach((item, index) => {
          options.baseOption.series[0].data[index] = {
            ...item,
            ...this.chart.series[index],
          }
        })
      }
      options.baseOption.legend.data = this.chart.legend

      return options
    },

    // Specifications data merged for selected products
    productsCategoriesScores() {
      const scoresByModel = Object.values(this.data.modelsScores).map(
        (model) => {
          return model
            .filter((category) => !isEmpty(category.value))
            .map((category) => ({
              label: category.label,
              value: category.value,
            }))
        },
      )

      return scoresByModel
    },
  },

  mounted() {
    this.drawChart()
  },

  methods: {
    drawChart() {
      const myChart = initChart(this.$refs.container)
      myChart.setOption(this.options)
    },
  },
}
